import React from 'react'
import moment from 'moment'
import { TableProps } from 'antd/lib/table'

import { ColumnProps } from 'src/components/Ant/Table'
import { Table, Text } from 'src/components/Ant'
import { R3Data } from 'src/store/ducks/reports/types'

const columns: ColumnProps<R3Data>[] = [
  {
    align: 'center',
    dataIndex: 'request_number',
    key: 'request_number',
    render: (value: string) => <Text>#{value}</Text>,
    title: 'web.report.3.data.request_number'
  },
  {
    dataIndex: 'participant_name',
    key: 'participant_name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.3.data.participant_name'
  },
  {
    dataIndex: 'activity_desc',
    ellipsis: true,
    key: 'activity_desc',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.3.data.activity_desc'
  },
  {
    dataIndex: 'local_name',
    ellipsis: true,
    key: 'local_name',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.3.data.local_name'
  },
  {
    dataIndex: 'reference_desc',
    key: 'reference_desc',
    render: (value: string) => <Text>{value}</Text>,
    title: 'web.report.3.data.reference_desc'
  },
  {
    dataIndex: 'started_date',
    key: 'started_date',
    render: (value: number) => (
      <Text>
        {moment
          .unix(value)
          .utc()
          .format('DD/MM/YYYY HH:mm')}
      </Text>
    ),
    title: 'web.report.3.data.started_date'
  },
  {
    dataIndex: 'ended_date',
    key: 'ended_date',
    render: (value: number) => (
      <Text>
        {moment
          .unix(value)
          .utc()
          .format('DD/MM/YYYY HH:mm')}
      </Text>
    ),
    title: 'web.report.3.data.ended_date'
  }
]

function TableDetail({ ...props }: TableProps<R3Data>) {
  return (
    <Table
      {...props}
      className="table-striped table-sm"
      columns={columns}
      pagination={false}
    />
  )
}

export default TableDetail
